export default function reportSchedulesDirective() {
  return {
    template: require('./report-package-reports.html'),
    controller: 'PRReportPackageReportsController',
    controllerAs: 'prReportPackageReportsVM',
    bindToController: true,
    replace: true,
    scope: {
      customerId: '@',
      reportPackage: '=',
    },
  };
}
